import React, { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Navbardeo from "../shared/Navbardeo";
import Sidebardeo from "../shared/Sidebardeo";
import { useLocation, useNavigate } from "react-router-dom";
import Footerdeo from "../shared/Footerdeo";
import Swal from "sweetalert2";
import StudentDetailsModal from "./StudentDetailsModal";
import axios from "axios";
import { Link } from "react-router-dom";
import config from "../../config";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardDoubleArrowLeft,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";

const TotalApplicant = () => {
  const [modal, setModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);

  const [showRejectedRemarksModal, setShowRejectedRemarksModal] =
    useState(false);
  const [selectedRemarks, setSelectedRemarks] = useState("");

  const [remark, setRemark] = useState("");
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);

  // For selection
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [approveLoading, setApproveLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const location = useLocation();
  const schoolCode = location.state?.schoolCode;
  const navigate = useNavigate();
  // Fetch students from API
  const fetchStudents = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${config.API_BASE_URL}/DEOTotalSchoolCheckDetails_CL9`,
        {
          deO_ID: sessionStorage.getItem("deoId"),
          schooL_CODE: schoolCode,
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("deotoken")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data?.status === 200) {
        setStudents(response.data.data?.deoTotalSchoolCheck_list || []);
      } else {
        setStudents([]);
      }
    } catch (error) {
      setStudents([]);
      Swal.fire("Error", "Failed to fetch students", "error");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!schoolCode) {
      navigate("/total-school");
    }
    fetchStudents();
  }, [fetchStudents]);

  const handleRejectClick = () => {
    if (selectedIds.length !== 1) {
      Swal.fire("Only one student can be rejected at a time.");
      return;
    }
    setShowRejectModal(true);
  };

  const handleRejectSubmit = async () => {
    if (!remark.trim()) {
      Swal.fire({
        title: "Remarks Required!",
        text: "Please enter your remarks before submitting.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }
    setRejectLoading(true);

    const deoId = sessionStorage.getItem("deoId");
    const id = selectedIds[0];

    try {
      await axios.post(
        `${config.API_BASE_URL}/PendingUpdateDEOStatusApproRejct_CL9`,
        {
          status: "REJECTED",
          statuS_CHANGE_BY: deoId,
          candidatE_ID: id,
          remarks: remark.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("deotoken")}`,
            "Content-Type": "application/json",
          },
        }
      );

      Swal.fire({
        title: "Successfully Rejected!",
        // text: "The application has been rejected successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });

      setShowRejectModal(false);
      setRemark("");
      setSelectedIds([]);
      setSelectAll(false);
      fetchStudents();
    } catch (error) {
      Swal.fire("Error", "Failed to reject the candidate.", "error");
      setShowRejectModal(false);
      setRemark("");
    } finally {
      setRejectLoading(false);
    }
  };

  const handleCloseRejectModal = () => {
    setShowRejectModal(false);
    setRemark("");
    setRejectLoading(false);
  };
  const token = sessionStorage.getItem("deotoken");

  const handleModalOpen = async (stu) => {
    try {
      const response = await axios.post(
        `${config.API_BASE_URL}/FetchDEODemographyData_CL9`,
        {
          candidatE_ID: stu.candidatE_ID,
          schooL_CODE: schoolCode,
          districtcode: sessionStorage.getItem("deoId"),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setSelectedStudent(response.data.data["deoDemography_data"] || {});

      setShowModal(true);
    } catch (error) {
      console.error("Error fetching student demography data", error);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedStudent(null);
  };

  const handleViewRemarks = (remarks) => {
    setSelectedRemarks(remarks || "No remarks available.");
    setShowRejectedRemarksModal(true);
  };

  // Helper to show correct badge
  const getStatusBadge = (status, remarks) => {
    if (status === "APPROVED")
      return <span className="badge bg-success text-white">APPROVED</span>;
    if (status === "REJECTED")
      return (
        <button
          className="btn btn-sm btn-danger"
          style={{ fontSize: "12px" }}
          onClick={() => handleViewRemarks(remarks)}
        >
          {" "}
          <i className="fa fa-times"></i>&nbsp;REJECTED
        </button>
      );
    //  <span className="badge bg-danger text-white">REJECTED</span>;
    return <span className="badge bg-warning text-white">PENDING</span>;
  };

  // Checkbox logic
  const isCheckboxEnabled = (status) => {
    return status === "PENDING";
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    if (checked) {
      const idsToSelect = students
        .filter((s) => isCheckboxEnabled(s.deO_STATUS))
        .map((s) => s.candidatE_ID);
      setSelectedIds(idsToSelect);
    } else {
      setSelectedIds([]);
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((cid) => cid !== id) : [...prev, id]
    );
  };

  useEffect(() => {
    if (!students.length) {
      setSelectAll(false);
      return;
    }
    const enabledIds = students
      .filter((s) => isCheckboxEnabled(s.deO_STATUS))
      .map((s) => s.candidatE_ID);
    setSelectAll(
      enabledIds.length > 0 &&
        enabledIds.every((id) => selectedIds.includes(id))
    );
  }, [selectedIds, students]);

  // ---- FIX: Add this function ----
  const handleApproveSelected = async () => {
    if (selectedIds.length === 0) {
      return Swal.fire("Select at least one student to approve.");
    }
    setApproveLoading(true);

    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "You are about to approve the selected students. Do you want to continue?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Approve",
      cancelButtonText: "Cancel",
    });

    if (!confirmResult.isConfirmed) {
      setApproveLoading(false);
      return;
    }

    const deoId = sessionStorage.getItem("deoId");

    try {
      const approvalPromises = selectedIds.map((id) =>
        axios.post(
          `${config.API_BASE_URL}/PendingUpdateDEOStatusApproRejct_CL9`,
          {
            status: "APPROVED",
            statuS_CHANGE_BY: deoId,
            candidatE_ID: id,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("deotoken")}`,
              "Content-Type": "application/json",
            },
          }
        )
      );

      await Promise.all(approvalPromises);

      Swal.fire(
        "Success",
        "Selected candidates approved successfully.",
        "success"
      );
      setSelectedIds([]);
      setSelectAll(false);
      fetchStudents();
    } catch (error) {
      console.error("Approval error:", error);
      Swal.fire("Error", "Failed to approve one or more candidates.", "error");
    } finally {
      setApproveLoading(false);
    }
  };
  // ---- END FIX ----
  const [searchQuery, setSearchQuery] = useState("");

  const filteredStudents = students.filter((student) => {
    const query = searchQuery.toLowerCase();
    return (
      student.candidatE_NAME?.toLowerCase().includes(query) ||
      student.dob?.toLowerCase().includes(query) ||
      student.fatheR_NAME?.toLowerCase().includes(query) ||
      student.motheR_NAME?.toLowerCase().includes(query) ||
      student.candidatE_ID?.toLowerCase().includes(query) ||
      student.deO_STATUS?.toLowerCase().includes(query)
    );
  });

  const totalPages = Math.ceil(filteredStudents.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredStudents.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  return (
    <div className="container-scroller d-flex flex-column min-vh-100">
      <Navbardeo />
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="container-fluid page-body-wrapper flex-grow-1 d-flex">
        <Sidebardeo />
        <div className="main-panel d-flex flex-column flex-grow-1">
          {/* ======= Content Wrapper ======= */}
          <div className="content-wrapper bg-light flex-grow-1 overflow-auto">
            {/* ======= Breadcrumb + Heading ======= */}
            <div className="container-fluid mt-3 px-4">
              <div className="d-flex justify-content-between align-items-center">
                <h3>Total Applicant</h3>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      {" "}
                      <Link
                        to="/deo-dashboard"
                        style={{ textDecoration: "none", color: "grey" }}
                      >
                        {" "}
                        <i
                          className="fa fa-tachometer"
                          style={{ marginRight: "5px" }}
                        ></i>
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Total Applicant
                    </li>
                  </ol>
                </nav>
              </div>
            </div>

            {/* ======= Table ======= */}
            <div className="container-fluid px-4">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="d-flex align-items-center">
                      <label htmlFor="rowsPerPage" className="me-2 mb-0">
                        Rows:
                      </label>
                      <div style={{ width: "250px" }}>
                        <select
                          id="rowsPerPage"
                          className="form-select form-select-sm"
                          value={perPage}
                          onChange={handlePerPageChange}
                          style={{
                            width: "80px", // or adjust as needed (80–120px)
                            paddingRight: "2rem", // ensures space for the dropdown arrow
                          }}
                        >
                          {[10, 20, 50, 100, 500].map((num) => (
                            <option key={num} value={num}>
                              {num}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {/* Search on the right */}
                    <div style={{ width: "200px" }}>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table
                      id="pendingApplicantsTable"
                      className="table table-bordered table-striped table-sm "
                    >
                      <thead className="table-light justify-center">
                        <tr>
                          <th>
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={selectAll}
                              disabled={
                                students.filter((s) =>
                                  isCheckboxEnabled(s.deO_STATUS)
                                ).length === 0
                              }
                            />
                          </th>
                          <th>Sl. No</th>
                          <th>Candidate ID</th>
                          <th>Candidate Name</th>
                          <th>Date of Birth</th>
                          <th>Father's Name</th>
                          <th>Mother's Name</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems?.length > 0 ? (
                          currentItems.map((student, index) => {
                            const status = student.deO_STATUS;
                            const id = student.candidatE_ID;
                            return (
                              <tr key={index}>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedIds.includes(id)}
                                    disabled={!isCheckboxEnabled(status)}
                                    onChange={() => handleCheckboxChange(id)}
                                  />
                                </td>
                                <td>{indexOfFirstItem + index + 1}</td>
                                <td>{student.candidatE_ID}</td>
                                <td>{student.candidatE_NAME}</td>
                                <td>{student.dob?.split(" ")[0]}</td>
                                <td>{student.fatheR_NAME}</td>
                                <td>{student.motheR_NAME}</td>
                                <td>
                                  {getStatusBadge(
                                    status,
                                    student.remarkS_REJECTED
                                  )}
                                </td>
                                <td>
                                  <div>
                                    <button
                                      className="btn btn-primary btn-sm mb-1"
                                      onClick={() => handleModalOpen(student)}
                                    >
                                      View Details
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="9" className="text-center text-muted">
                              No students found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        Showing {(currentPage - 1) * perPage + 1} to{" "}
                        {Math.min(indexOfLastItem, filteredStudents.length)} of{" "}
                        {filteredStudents.length} entries
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <MdOutlineKeyboardDoubleArrowLeft
                          onClick={() => {
                            if (currentPage > 1) setCurrentPage(1);
                          }}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardArrowLeft
                          onClick={() => {
                            if (currentPage > 1)
                              setCurrentPage((prev) => prev - 1);
                          }}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <span>
                          Page {currentPage} of {totalPages}
                        </span>

                        <MdOutlineKeyboardArrowRight
                          onClick={() => {
                            if (currentPage < totalPages)
                              setCurrentPage((prev) => prev + 1);
                          }}
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardDoubleArrowRight
                          onClick={() => {
                            if (currentPage < totalPages)
                              setCurrentPage(totalPages);
                          }}
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />
                      </div>
                    </div>

                    {/* ======= Buttons ======= */}
                    <div className="mt-3 d-flex justify-content-end gap-2">
                      <button
                        className="btn btn-success"
                        onClick={handleApproveSelected}
                        disabled={approveLoading || selectedIds.length === 0}
                      >
                        {approveLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Approving...
                          </>
                        ) : (
                          <>✓ Approve</>
                        )}
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={handleRejectClick}
                        disabled={selectedIds.length === 0}
                      >
                        {rejectLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Rejecting...
                          </>
                        ) : (
                          <>✗ Reject</>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {showModal && (
            <StudentDetailsModal
              show={showModal}
              handleClose={handleModalClose}
              studentData={selectedStudent}
            />
          )}

          {showRejectModal && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Rejection Remark</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleCloseRejectModal}
                      disabled={rejectLoading}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label htmlFor="remark" className="form-label">
                        Remark <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        id="remark"
                        rows="3"
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                        placeholder="Enter reason for rejection"
                        disabled={rejectLoading}
                      ></textarea>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={handleCloseRejectModal}
                      disabled={rejectLoading}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={handleRejectSubmit}
                      disabled={rejectLoading}
                    >
                      {rejectLoading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Submitting...
                        </>
                      ) : (
                        <>Submit Remark & Reject</>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ======= Fixed Footer ======= */}
          <div className="bg-white shadow-sm">
            <Footerdeo />
          </div>
        </div>
      </div>
      <AnimatePresence>
        {showRejectedRemarksModal && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1050,
            }}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="modal-content p-4 bg-white rounded"
              style={{ width: "400px", position: "relative" }}
            >
              <h5 className="mb-3">DEO Rejection Remarks</h5>
              <textarea
                className="form-control"
                rows="5"
                value={selectedRemarks}
                readOnly
              />
              <div className="text-end mt-3">
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => setShowRejectedRemarksModal(false)}
                >
                  Close
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default TotalApplicant;
